import {
  GET_CRISIS_LIST,
  SET_CRISIS_DETAIL,
  CRISIS_RECORDS_SET,
  CRISIS_LOADING,
  CRISIS_PATCH,
} from "./CrisisType";

export const CrisisReducer = (
  state = {
    List: [],
    Detail: null,
    RecordCounts: {},
    Records: {},
    loading: false,
  },
  action,
) => {
  switch (action.type) {
    case CRISIS_LOADING:
      return { ...state, loading: Boolean(action.Payload) };
    case GET_CRISIS_LIST:
      return { ...state, List: action.Payload || [] };
    case SET_CRISIS_DETAIL:
      return {
        ...state,
        Detail: action.Payload?.crisis ?? null,
        RecordCounts: action.Payload?.recordCounts ?? {},
      };
    // Patch one crisis in place after a mutation, so the list card reflects
    // the change immediately (toggling "passed" used to need a re-mount).
    case CRISIS_PATCH: {
      const updated = action.Payload;
      if (!updated?._id) return state;
      const id = String(updated._id);
      return {
        ...state,
        List: (state.List || []).map((c) =>
          String(c._id) === id ? { ...c, ...updated } : c,
        ),
        Detail:
          state.Detail && String(state.Detail._id) === id
            ? { ...state.Detail, ...updated }
            : state.Detail,
      };
    }
    case CRISIS_RECORDS_SET:
      return {
        ...state,
        Records: {
          ...state.Records,
          [action.Payload.key]: action.Payload.data,
        },
      };
    default:
      return state;
  }
};
